import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import set from 'lodash/set';
import isArray from 'lodash/isArray';
import url from 'url';

const DOMAIN_KEY = 'domainKey';

let instance = null;
let digitalData;

export default class MyDigitalData {

  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  init(d, siteProps = {}, overrides) {
    digitalData = d || {};
    digitalData.version = '.1';
    digitalData.pageInstanceID = get(siteProps, DOMAIN_KEY, '');
    digitalData.page = {
      attributes: this.getAttributes(siteProps),
      category: '',
      pageInfo: this.getPageInfo(siteProps),
    };

    if (!isEmpty(overrides)) {
      this.set(overrides);
    }
  }

  getBrandToken(siteProps) {
    return get(siteProps, 'brandToken', 'none').toLowerCase();
  }

  getAttributes(siteProps) {
    return {
      brand: this.getBrandToken(siteProps),
    };
  }

  getCampaignName(inUrl) {
    let cName;

    if (inUrl) {
      const urlParams = url.parse(inUrl, true);
      cName = this.parseCampaignName(urlParams);
    }

    return cName;
  }

  getPageInfo(siteProps) {
    const pageUrl = window.location.href;

    return {
      campaign: this.getCampaignName(pageUrl),
      destinationURL: document.location.href,
      domain: get(siteProps, DOMAIN_KEY, ''),
      geoRegion: get(siteProps, 'siteRegion', '').toLowerCase(),
      hostSystem: get(siteProps, 'systemName', ''),
      language: get(siteProps, 'language', ''),
      pageChannel: '',
      pageID: '',
      pageName: '',
      referringURL: document.referrer,
      sysEnv: window.innerWidth < 720 ? 'mobile' : 'desktop',
    };
  }

  parseCampaignName(params) {
    const c = params.query.c;
    const wt = params.query['wt.mc_id'];

    if (c && wt) {
      return c + wt;
    } else if (c) {
      return c;
    }

    return wt;
  }

  get(key) {
    return get(digitalData, key);
  }

  set(items) {
    if (!digitalData || !isArray(items)) {
      return;
    }

    for (let i = 0; i < items.length; i++) {
      set(digitalData, items[i][0], items[i][1]);
    }
  }
}
